module.exports = __webpack_public_path__ + "30dd260219ab94ef4ecc0d380aef463e.png";